import React from 'react';
import { Award, Stethoscope, Calendar, GraduationCap, Star, Users } from 'lucide-react';
import '../styles/AboutPage.css';

const AboutPage = () => {
  const experiences = [
    {
      period: '2022 حتى الآن',
      position: 'استشاري نساء وتوليد وجراحة',
      hospital: 'مستشفى الإمارات التخصصي، دبي'
    },
    {
      period: '2019 - 2021',
      position: 'استشاري نساء وتوليد وجراحة',
      hospital: 'مركز الدكتور سليمان الحبيب الطبي، دبي'
    },
    {
      period: '2018',
      position: 'استشاري نساء وتوليد وجراحة',
      hospital: 'مستشفى NMC، دبي'
    },
    {
      period: '2015 - 2018',
      position: 'أخصائي نساء وتوليد وجراحة',
      hospital: 'المستشفى السعودي الألماني، دبي'
    },
    {
      period: '2012 - 2015',
      position: 'رئيس قسم أخصائي نساء وتوليد وجراحة',
      hospital: 'مستشفى الشرق، الفجيرة'
    },
    {
      period: '2000 - 2012',
      position: 'أخصائي نساء وتوليد وجراحة',
      hospital: 'عيادتي الخاصة، دمشق'
    },
    {
      period: '1991 - 2000',
      position: 'أخصائي طب أطفال',
      hospital: 'عيادتي الخاصة، دمشق'
    },
    {
      period: '1987 - 1991',
      position: 'أخصائي طب أطفال',
      hospital: 'وزارة الصحة، دمشق'
    }
  ];

  const specialties = [
    {
      icon: <Stethoscope />,
      title: 'جراحة الأورام النسائية',
      description: 'تشخيص وعلاج الأورام النسائية المتخصصة'
    },
    {
      icon: <Award />,
      title: 'جراحة المناظير الدقيقة',
      description: 'عمليات جراحية متقدمة بأقل تدخل جراحي'
    },
    {
      icon: <GraduationCap />,
      title: 'فحص عنق الرحم بالمنظار',
      description: 'تشخيص دقيق لأمراض عنق الرحم'
    },
    {
      icon: <Calendar />,
      title: 'رعاية الحمل المبكر',
      description: 'متابعة شاملة للحمل في مراحله الأولى'
    },
    {
      icon: <Star />,
      title: 'النساء الحادة',
      description: 'تشخيص وعلاج الحالات النسائية الطارئة'
    },
    {
      icon: <Users />,
      title: 'فحوصات الموجات فوق الصوتية',
      description: 'فحوصات دقيقة باستخدام أحدث التقنيات'
    }
  ];

  const qualifications = [
    'شهادة البورد في طب النساء والتوليد',
    'دبلوم جراحة التجميل النسائية - القصر العيني',
    'دبلوم الإخصاب المساعد - جامعة القاهرة',
    'خبرة 21 سنة في مجال النساء والتوليد',
    'عضوية الجمعيات الطبية المتخصصة',
    'مشاركة في المؤتمرات الطبية العالمية'
  ];

  return (
    <div className="about-page" dir="rtl">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content">
          <h1 className="about-hero-title">من نحن</h1>
          <p className="about-hero-subtitle">التعريف بفريقنا الطبي المتميز</p>
        </div>
      </section>

      {/* Main Content */}
      <div className="about-container">
        {/* Doctor Profile Section */}
        <section className="doctor-profile-section">
          <div className="doctor-profile">
            <div className="doctor-image-container">
              <div className="doctor-image-wrapper">
                <img 
                  src="../../images/basema.jpg" 
                  alt="الدكتورة باسمة جابر"
                  className="doctor-image"
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/400x500/3b82f6/ffffff?text=Dr.+Basema+Jaber';
                  }}
                />
                <div className="doctor-image-overlay">
                  <div className="experience-badge">
                    <Calendar className="experience-icon" />
                    <span>21 سنة خبرة</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="doctor-info">
              <div className="doctor-header">
                <h2 className="doctor-name">الدكتورة باسمة جبر</h2>
                <p className="doctor-title">استشاري نساء وتوليد وجراحة</p>
              </div>

              <div className="doctor-statement">
                <h3 className="section-title">السيرة المهنية</h3>
                <p className="statement-text">
                  أنا محظوظة لامتلاكي خبرة واسعة في مجال طب النساء والتوليد تمتد على مدار 21 عاماً. 
                  عملت في مجموعة متنوعة من المستشفيات، بدءاً من المستشفيات الجامعية وصولاً إلى المستشفيات العامة الإقليمية.
                </p>
                <p className="statement-text">
                  اهتماماتي الخاصة في مجال طب النساء تشمل: أورام النساء، جراحة المناظير الدقيقة، فحص عنق الرحم بالمنظار، 
                  رعاية الحمل المبكر، والنساء الحادة مع فحوصات الموجات فوق الصوتية.
                </p>
                <p className="statement-text">
                  أعتبر نفسي طبيبة نساء متمرسة وواثقة في إجراء العمليات الجراحية النسائية عن طريق البطن، المهبل، 
                  والمناظير المتقدمة، سواء في الحالات الطارئة أو كحالات جراحية معقدة.
                </p>
              </div>

              <div className="doctor-qualifications">
                <h3 className="section-title">المؤهلات العلمية</h3>
                <div className="qualifications-list">
                  {qualifications.map((qual, index) => (
                    <div key={index} className="qualification-item">
                      <div className="qualification-check">
                        <i className="fas fa-check"></i>
                      </div>
                      <span>{qual}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Specialties Section */}
        <section className="specialties-section">
          <div className="section-header">
            <h2 className="section-title">التخصصات الطبية</h2>
            <p className="section-subtitle">مجالات التخصص والخبرة الطويلة</p>
          </div>

          <div className="specialties-grid">
            {specialties.map((specialty, index) => (
              <div key={index} className="specialty-card">
                <div className="specialty-icon">
                  {specialty.icon}
                </div>
                <h3 className="specialty-title">{specialty.title}</h3>
                <p className="specialty-description">{specialty.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Experience Timeline */}
        <section className="experience-section">
          <div className="section-header">
            <h2 className="section-title">الخبرة العملية</h2>
            <p className="section-subtitle">رحلة مهنية حافلة بالإنجازات</p>
          </div>

          <div className="timeline">
            {experiences.map((exp, index) => (
              <div key={index} className={`timeline-item ${index % 2 === 0 ? 'right' : 'left'}`}>
                <div className="timeline-content">
                  <div className="timeline-period">{exp.period}</div>
                  <h3 className="timeline-position">{exp.position}</h3>
                  <p className="timeline-hospital">{exp.hospital}</p>
                </div>
                <div className="timeline-dot">
                  <div className="dot-inner"></div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Clinic Services */}
        <section className="services-section">
          <div className="section-header">
            <h2 className="section-title">خدمات العيادة</h2>
            <p className="section-subtitle">رعاية شاملة ومتابعة مستمرة</p>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <div className="service-number">01</div>
              <h3 className="service-title">عيادات التخصص</h3>
              <ul className="service-list">
                <li>عيادة المنظار النسائي الخارجي</li>
                <li>عيادة متابعة الحمل عالي الخطورة</li>
                <li>عيادة فحص عنق الرحم بالمنظار</li>
                <li>عيادة رعاية الحمل المبكر</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-number">02</div>
              <h3 className="service-title">الجراحات المتخصصة</h3>
              <ul className="service-list">
                <li>جراحات الأورام النسائية</li>
                <li>جراحات المناظير المتقدمة</li>
                <li>جراحة التجميل النسائية</li>
                <li>عمليات الإخصاب المساعد</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-number">03</div>
              <h3 className="service-title">الفحوصات التشخيصية</h3>
              <ul className="service-list">
                <li>فحوصات الموجات فوق الصوتية</li>
                <li>فحوصات الحمل المتقدمة</li>
                <li>فحوصات الخصوبة</li>
                <li>فحوصات ما قبل الزواج</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Philosophy Section */}
        <section className="philosophy-section">
          <div className="philosophy-content">
            <div className="philosophy-icon">
              <i className="fas fa-heartbeat"></i>
            </div>
            <h2 className="philosophy-title">فلسفتنا في الرعاية الطبية</h2>
            <p className="philosophy-text">
              نؤمن في عيادتنا بأن الرعاية الطبية الشاملة والمتخصصة هي حق لكل مريضة. 
              نلتزم بتقديم أفضل الخدمات الطبية المبنية على أحدث الأبحاث العلمية والتقنيات الحديثة، 
              مع الحفاظ على الجانب الإنساني والتعاطف في التعامل مع كل حالة.
            </p>
            <p className="philosophy-text">
              نسعى دائماً لتحقيق أعلى معايير الجودة والأمان الطبي، مع التركيز على التعليم والتوعية الصحية 
              للمريضات لتمكينهن من اتخاذ القرارات الطبية المناسبة لحالتهن.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;